import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class PreloaderService {

  public isLoading: boolean;
  public isLoaderChange: Subject<boolean>;

  constructor() {
    this.isLoading = true;
    this.isLoaderChange = new Subject<boolean>();
  }

  /**
   * Purpose: To notify all the subscribed component for hiding the Preloader Component
   */
  hidePreLoader() {
    this.isLoading = false;
    this.isLoaderChange.next(this.isLoading);
  }

  /**
   * Purpose: To notify all the subscribed component for displaying the Preloader Component
   */
  showPreLoader() {
    this.isLoading = true;
    this.isLoaderChange.next(this.isLoading);
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/preloader/preloader.service.ts